/**
 * Перечитывание `Me`.
 *
 * Отдельный модуль, чтобы разорвать цикл `bootstrap` ↔ `engine-callbacks`:
 * обработчики движка обновляют профиль, но не должны тянуть за собой всю
 * стартовую последовательность.
 */
import { api, setApiLocale, unwrap } from '@shared/api/client'
import { getActiveUserId, meRepo, mirrorSettingsForWorker } from '@shared/db'

import { useAppStore } from '../model/app-store'
import { applyDocumentLanguage } from '../model/locale'
import { notifyAccountActivated } from './activation'

/** Перечитывает `Me` — после onboarding, смены настроек, возврата в foreground. */
export async function refreshMe(): Promise<void> {
  try {
    const me = unwrap(await api.GET('/me'))
    const store = useAppStore.getState()

    store.setMe(me)
    /*
     * Реплика — источник `Me` для экранов (зеркало в me-mirror.ts): без записи
     * сюда следующий `me.updated` с частичной дельтой накладывался бы на
     * устаревшую запись и возвращал в интерфейс старые способы входа, фото
     * и режимы. Версия сверяется в репозитории: более старая запись не перекроет новую.
     */
    if ((await getActiveUserId()) === me.user.id) {
      await meRepo.put(me).catch(() => undefined)
    }
    setApiLocale(me.settings.locale || 'ru')
    applyDocumentLanguage(me.settings.locale || 'ru')
    await mirrorSettingsForWorker(me.settings.locale || 'ru', me.settings.notif_preview)

    if (store.phase === 'onboarding' && me.user.status === 'active') {
      store.setPhase('ready')
      // Аккаунт стал active — теперь можно поднимать синхронизацию (BS §5.7).
      notifyAccountActivated(me)
    }
    if (store.phase === 'ready' && me.user.status === 'onboarding') store.setPhase('onboarding')
  } catch {
    // Ошибка обновления не должна ронять уже работающий интерфейс.
  }
}
